export default __webpack_public_path__ + "static/media/logo-erkam.c3c2c2d7.png";